import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RatingService {

  constructor(private http: HttpClient ) { 
    
  }

  ratingRestaurantAndDeliveryMan(body){
    return this.http.put(`${environment.apiUrl}feedback/updatefeedback`, body)
  } 


}
